export default (self, type) => {
  /* eslint-disable no-plusplus */
  if (!self.$overflowScrollingList.length) return
  for (let i = 0; i < self.$overflowScrollingList.length; i++) {
    self.$overflowScrollingList[i].style.webkitOverflowScrolling = type
  }
}



// WEBPACK FOOTER //
// ./client/utils/safari-fix.js